/////////////////////////////////
// OLD FLOW INITIALIZING CTA CODE
/////////////////////////////////
// (function ($) {
// 	var modal = new tingle.modal({
// 		closeMethods: ['overlay', 'escape'],
// 	});

// 	var content = $('.js-lead-form-modal-content').html();
// 	modal.setContent(content);

// 	$('.js-lead-form-modal').click(function () {
// 		// modal.open();
// 	});

// 	$('.js-lead-form-modal--close').click(function () {
// 		// modal.close();
// 	});
// })(jQuery);

/////////////////////////////////
// NEW HVAC-COMPONENT MULTI STEP LEAD FORM CTA
/////////////////////////////////
(() => {
	window.addEventListener('load', function () {

		document.querySelector(' .js-close-modal-form ').addEventListener('click', (event) => {
			document.querySelector('.modal-form').classList.add('hide');
		});

		document.querySelectorAll(' .js-open-modal-form ').forEach((item) => {
			item.addEventListener('click', (event) => {
				event.preventDefault();
				document.querySelector('.modal-form').classList.remove('hide');

				if (!document.querySelector('#modalForm .hvac-multi')) {
					const modalFormExp = {
						modalMultiStep() {
							HVAC.formCentral.createMultiStep({
								placement: '#modalForm',
								formKey: 'modalForm',
								formId: 'MODAL_MULTISTEP_FORM',
								formName: 'OVERLAY_MULTISTEP_FORM',
								formType: 'LEAD',
								companyId: 'disabled',
								tcpa: 'By entering your phone number and clicking the "Submit" button above, I agree to the following: FurnaceCompare.com\'s Privacy Policy and Terms of Use. I am providing my prior express written consent to share my information with FurnaceCompare.com\'s, Networx, and Networx\'s authorized parties calling on their behalf, to deliver calls or text messages to my phone number provided above, for the purpose of home improvement requests & contractor bids, using an automated telephone dialing system or an artificial or prerecorded voice. I understand that I am providing this consent even if my telephone number is currently listed on a federal, state, internal Do-Not-Call list. I understand that I do not have to agree to receive these types of calls or text messages as a condition for purchasing any goods or services, and that message and data rates may apply.',
								payloadData: {
									brand: 'FURNACE_COMPARE',
									kind: 'CONTACT_DEALER',
									source: 'FURNACE_COMPARE:EMAIL_FORM',
								},
								progressBar: {
									showSteps: false,
								},
								steps: [
									{
										stepId: 'helpType',
										title: 'What do you need help with?',
										description: 'Tell us what you need and we\'ll find the best professional for your project',
										btnControlText: ['Next'],
										inputs: [
											{
												label: '',
												name: 'helpType',
												type: 'button-group',
												buttons: [
													{
														name: 'New System',
														track: {
															actionOutcome: 'GROUPSELECTION', // made up
															elementType: 'BUTTON',
															location: 'MODAL LEAD FORM',
															text: 'NEW SYSTEM',
														},
													},
													{
														name: 'Repair System',
														track: {
															actionOutcome: 'GROUPSELECTION', // made up
															elementType: 'BUTTON',
															location: 'MODAL LEAD FORM',
															text: 'REPAIR SYSTEM',
														},
													},
												],
												track: {
													fieldLabel: 'Help Type',
													fieldType: 'BUTTON',
													stepNumber: 1,
													stepName: 'HELP TYPE',
												},
												validation: [
													{ type: 'required', value: 'Input is required' },
												],
											}],
									},
									{
										stepId: 'zipCode',
										title: 'Where do you need service?',
										description: 'This helps us find top-rated specialists in your area',
										btnControlText: ['Next', 'Back'],
										inputs: [
											{
												label: 'Zip Code',
												name: 'zip',
												type: 'text',
												track: {
													fieldLabel: 'Zip Code',
													fieldType: 'ZIP CODE',
													stepNumber: 2,
													stepName: 'ZIP CODE',
												},
												validation: [
													{ type: 'required', value: 'Input is required' },
													{ type: 'zip', value: 'Zip code is invalid' },
												],
											},
										],
									},
									{
										stepId: 'multiName',
										title: 'Your personal info is secure',
										description: 'Our experts need some information to confirm the details of your appointment',
										btnControlText: ['Next', 'Back'],
										inputs: [
											{
												label: 'First Name',
												name: 'firstName',
												type: 'text',
												track: {
													fieldLabel: 'First Name',
													fieldType: 'FIRST NAME',
													stepNumber: 3,
													stepName: 'FIRST NAME',
												},
												validation: [
													{ type: 'required', value: 'Input is required' },
												],
											},
											{
												label: 'Last Name',
												name: 'lastName',
												type: 'text',
												track: {
													fieldLabel: 'Last Name',
													fieldType: 'LAST NAME',
													stepName: 'LAST NAME',
												},
												validation: [
													{ type: 'required', value: 'Input is required' },
												],
											},
										],
									},
									{
										stepId: 'email',
										title: 'How can we contact you?',
										description: 'Please provide your email address to connect with an HVAC specialist in your area',
										btnControlText: ['Next', 'Back'],
										inputs: [
											{
												label: 'Email Address',
												name: 'email',
												type: 'text',
												track: {
													fieldLabel: 'Email',
													fieldType: 'EMAIL',
													stepNumber: 4,
													stepName: 'EMAIL',
												},
												validation: [
													{ type: 'required', value: 'Input is required' },
													{ type: 'email', value: 'Please enter a valid email address' },
												],
											},
										],
									},
									{
										stepId: 'testMultiPhone',
										title: 'Your personal info is secure',
										description: 'Let us know the best way to contact you once we find a recommended HVAC professional in your area.',
										note: '<p>By entering your phone number and clicking the "Submit" button, I agree to the following:</p><ul><li>I am providing my prior express written consent to share my information with www.www.bluezima.com\'s, Networx, and Networx authorized parties calling on their behalf, to deliver calls or text messages to my phone number provided above, for the purpose of home improvement requests & contractor bids, using an automated telephone dialing system or an artificial or prerecorded voice. I understand that I am providing this consent even if my telephone number is crrently listed on a federal, state, internal Do-Not-Call list. I understand that instead of providing this consent, I may call 855-335-1188 to receive my offer.</li><li>www.www.bluezima.com\'s <a href="/privacy/">Privacy Policy</a> and <a href="/terms/">Terms of Use</a>.</li></ul><p>I understand that I do not have to agree to receive these types of calls or text messages as a condition for purchasing any goods or services, and that message and data rates may apply.</p>',
										btnControlText: ['Submit', 'Back'],
										inputs: [
											{
												label: 'Phone Number',
												name: 'phone',
												type: 'text',
												track: {
													fieldLabel: 'Phone',
													fieldType: 'PHONE',
													stepNumber: 5,
													stepName: 'PHONE',
												},
												validation: [
													{ type: 'required', value: 'Phone number is required' },
													{ type: 'phone', value: 'Phone number is invalid' },
												],
											},
										],
									},
								],
								success: {
									iconClassName: '',
									title: 'You\'re all set!',
									subTitle: 'We\'ll match you with a top-rated HVAC professional who can help.',
									message: 'An HVAC pro will contact you soon.',
									buttons: [
										{
											name: 'Close',
											track: {
												fieldLabel: 'Close',
												fieldType: 'BUTTON',
											},
											url: '#0',
										},
									],
								},
								error: {
									iconClassName: '',
									title: 'Error',
									subTitle: 'Ooops! Something went wrong!',
									message: 'Please try again.',
									buttons: [
										{
											name: 'Close',
											track: {
												fieldLabel: 'Close',
												fieldType: 'BUTTON',
											},
											url: '#0',
										},
									],
								},
							});
						},

						onLeadFormSubmit() {
							document.addEventListener('HVACFormSubmit', (event) => {
								document.querySelector('.modal-form__call-text').classList.add('hide');
								document.querySelector('.hvac-messaging-state__sub-title').insertAdjacentHTML('afterend', '<div style="width: 200px; height: 1px; background: #6fa5c7; margin: 35px auto;"></div>');

								document.querySelector(' .hvac-messaging-state a').addEventListener('click', (event) => {
									document.querySelector('.modal-form').classList.add('hide');
								});
							});
						},
					};

					function initForms() {
						// initialize forms
						modalFormExp.modalMultiStep();
						modalFormExp.onLeadFormSubmit();
					}

					initForms();
				}
			});
		});
	});
})();



// WEBPACK FOOTER //
// ./assets/js/partials/lead-form-modal.js